module.exports = __webpack_public_path__ + "fonts/Segoe UI.0e7e9a9b.ttf";